module.exports = __webpack_public_path__ + "img/background.5c84cda9.png";